import { DefaultTheme } from 'styled-components'
import colors_ from 'core/theme/colors'

const swmColors = {
    primary100: '#001a72',
    primary80: '#2e4593',
    primary60: '#5a6fb6',
    primary40: '#919fcf',
    primary20: '#c2c7e4',
    accentYellow: '#ffe780',
    accentBlue: '#87cce8',
    accentRed: '#ffa3a1',
    accentGreen: '#b1dfd0',
    white: '#fff'
}
const colors = {
    ...colors_,
    tealDarkest: '#167387',
    tealDarker: '#2594AC',
    tealDark: '#2EB1CE',
    teal: '#47CFED',
    tealLight: '#6BDAF2',
    tealLighter: '#92E4F6',
    tealLightest: '#BFF4FF',
    pinkDark: '#9D0E66',
    pink: '#ef4e88',
    pinkLight: '#FE79B4',
    pinkLighter: '#FFADD2',
    pinkLightest: '#FFCEE4',
    redDark: '#c3494e',
    red: '#FE6A6A',
    redLight: '#FF8686',
    redLighter: '#FFA3A3',
    redLightest: '#FFC2C2',
    blue: '#3633B7',
    blueLight: '#775CE0',
    blueLighter: '#B0AEEF',
    blueLightest: '#D0CFF9',
    purpleDarkest: '#3E1A4D',
    purpleDarker: '#532566',
    purpleDark: '#6D3385',
    purple: '#8D4CA8',
    purpleLight: '#A964C6',
    purpleLighter: '#C185DA',
    purpleLightest: '#D5A7E8',
    purpleLightester: '#EFDCF8',
    green: '#4BC77D',
    greenLight: '#73D49A',
    greenLighter: '#B6F4CF',
    white: '#FFF6E6',
    yellowLight: '#FFF1C0',
    yellow: '#FFE589',
    greyDarker: '#303435',
    greyDark: '#4E5557',
    grey: '#8B8085',
    greyLight: colors_.brandSeaBlue40,
    greyLighter: '#DED1D7',
    greyLightest: '#EADEE3',

    kakiDark: '#9ca033',
    kaki: '#CCD133',
    electricBlueLight: '#AEF0FF',
    electricBlue: '#38D6FE',
    electricBlueDark: '#21B1D6',
    electricBlueDarker: '#129DC0',
    electricBlueDarkerer: '#07657D',
    electricBlueDarkest: '#224149',
    electricBlueDarkestest: '#0C2B33',
    electricBlueMuted1: '#314448',
    orangeLight: '#FFBA53',
    orange: '#EC9C23',
    orangeDark: '#D98C18',
    orangeDarker: '#BE780F',
    yellowDark: '#ECCB55',
    yellowDarker: '#D2AA19',

    blueGreenLightest: '#C9FFF2',
    blueGreenLighter: colors_.brandGreen20,
    blueGreenLight: '#75FBDA',
    blueGreen: '#51F2CB',
    blueGreenDark: colors_.brandGreen100,
    blueGreenDarker: colors_.brandGreen100,
    blueGreenDarkest: '#16AF8A',

    lilacLighter: '#E9DCFF',
    lilacLight: '#DCC7FF',
    lilac: '#BD95FF',
    lilacDark: '#B896EF',
    lilacDarker: '#A17AE0',
    lilacDarkerer: '#815CBF',
    lilacDarkest: '#6A499D',
    lilacDarkest2: '#604B81',
    lilacDarkest3: '#503E6A',
    lilacDarkest4: '#3A3444'
}

// const velocity = [
//     '#44168E',
//     '#491D90',
//     '#6532B7',
//     '#A17AE0',
//     '#AD84EF',
//     '#CAAAFF',
//     '#DCC7FF',
//     '#E9DCFF',
//     '#F8DCFF',
//     '#FFB5F3',
//     '#F494E5',
//     '#F176DD',
//     '#EF55D6',
//     '#DE35C3'
// ]

const velocity = [
    '#06513F',
    '#087258',
    '#0C8C6D',
    '#16AF8A',
    '#EBFCF7',
    '#34E1B7',
    '#51F2CB',
    '#75FBDA',
    '#82CAB2',
    '#C9FFF2',
    '#c9f7ff',
    '#d7e7fe',
    '#E9DCFF',
    '#DCC7FF',
    '#CAAAFF',
    '#AD84EF',
    '#8e5ddb',
    '#6b36bf',
    '#50219B',
    '#370D7A',
    '#2A0564'
]

const arrowsVelocity = [
    '#FF6259', // Full opacity
    '#FF7A73', // Lighter for 0.9 opacity
    '#FF938D', // Lighter for 0.8 opacity
    '#FFABA7', // Lighter for 0.7 opacity
    '#FFC4C1', // Lighter for 0.6 opacity
    '#FFDCD9', // Lighter for 0.5 opacity
    '#57B495', // Full opacity
    '#6FC1A5', // Lighter for 0.9 opacity
    '#87CDB5', // Lighter for 0.8 opacity
    '#9FD9C5', // Lighter for 0.9 opacity
    '#B7E6D5' // Lighter for 1.0 opacity
]

const tiers = [colors.red, '#ffc38a', '#feff8e', '#c3ff89']

const distinct = [
    colors.indigo,
    colors.teal,
    colors.pink,
    colors.red,
    colors.green,
    colors.yellow,
    colors.aqua,
    colors.orange,
    colors.olive,
    colors.skyblue,
    colors.purple,
    colors.blueLighter,
    colors.greyTeal,
    colors.kaki
]

const stateOfRNThemeColors: DefaultTheme['colors'] = {
    primary100: colors_.primary100,
    primary80: colors_.primary80,
    primary60: colors_.primary60,
    primary40: colors_.primary40,
    primary20: colors_.primary20,

    accentYellow: colors_.accentYellow,
    accentBlue: colors_.accentBlue,
    accentRed: colors_.accentRed,
    accentGreen: colors_.accentGreen,
    brandGreen100: colors_.brandGreen100,
    brandGreen80: colors_.brandGreen80,
    brandGreen60: colors_.brandGreen60,
    brandGreen40: colors_.brandGreen40,
    brandGreen20: colors_.brandGreen20,

    brandPink100: colors_.brandPink100,
    brandPink80: colors_.brandPink80,
    brandPink60: colors_.brandPink60,
    brandPink40: colors_.brandPink40,
    brandPink20: colors_.brandPink20,

    brandYellow40: colors_.brandYellow40,

    brandSeaBlue80: colors_.brandSeaBlue80,
    brandSeaBlue40: colors_.brandSeaBlue40,
    brandSeaBlue20: colors_.brandSeaBlue20,

    background: swmColors.white,
    backgroundTrans: swmColors.primary20,
    backgroundAlt3: swmColors.primary20,
    backgroundBackground: swmColors.primary20,
    backgroundForeground: colors.navyLighter,
    backgroundAlt: swmColors.primary20,
    backgroundAltTrans: 'rgba(49, 68, 72, 0.4)',
    backgroundAlt2: colors.electricBlueDarkerer,
    backgroundInverted: '#FFF6E6',
    backgroundInvertedAlt: '#E3D8C4',
    text: swmColors.primary100,
    textAlt: swmColors.primary80,
    textInverted: swmColors.primary20,
    textHighlight: colors.greenDark,
    link: swmColors.primary100,
    linkActive: '#5C63E0',
    contrast: '#0bdf67',
    border: swmColors.primary80,
    borderAlt: swmColors.primary80,
    heatmap: colors.pinkLight,
    lineChartDefaultColor: '#59DF7F',
    no_answer: [colors.greyLight, colors.greyLightest],
    velocityBarColors: velocity.map((color, i) => ({
        id: `velocityColor${i}`,
        color: velocity[i * 2],
        gradient: [velocity[i * 2 + 1], velocity[i * 2]]
    })),
    // bar colors for variants when using filters and (especially) facets
    barColors: [
        {
            id: 'barColor1',
            color: colors.purple,
            gradient: [colors.purple, colors.purpleLighter]
        },
        {
            id: 'barColor2',
            color: colors.pink,
            gradient: [colors.pinkDark, colors.pink]
        },
        {
            id: 'barColor3',
            color: colors.yellow,
            gradient: [colors.yellowDark, colors.yellow]
        },
        {
            id: 'barColor4',
            color: colors.greyTeal,
            gradient: [colors.greyTeal, colors.greyTealLight]
        },
        {
            id: 'barColor5',
            color: colors.olive,
            gradient: [colors.oliveDark, colors.olive]
        },
        {
            id: 'barColor6',
            color: colors.orange,
            gradient: [colors.orangeDarker, colors.orangeLight]
        },
        {
            id: 'barColor7',
            color: colors.aqua,
            gradient: [colors.aquaDark, colors.aqua]
        },
        {
            id: 'barColor8',
            color: colors.red,
            gradient: [colors.redDark, colors.red]
        },
        {
            id: 'barColor9',
            color: colors.skyblue,
            gradient: [colors.skyblueDark, colors.skyblue]
        },
        {
            id: 'barColor10',
            color: colors.kaki,
            gradient: [colors.kakiDark, colors.kaki]
        },
        {
            id: 'barColor11',
            color: colors.green,
            gradient: [colors.greenDark, colors.green]
        }
    ],
    barColorDefault: {
        id: 'barColorDefault',
        color: colors.blueGreenDark,
        gradient: [colors.blueGreenDark, colors.blueGreenDark]
    },
    barColorNoAnswer: {
        id: 'barColorNoAnswer',
        color: colors.greyLight,
        gradient: [colors.greyLight, colors.greyLightest]
    },
    barChart: {
        primary: colors.brandGreen60,
        primaryGradient: [colors.brandGreen60, colors.brandGreen60],
        positiveGradient: [colors.brandSeaBlue80, colors.brandSeaBlue80],
        negativeGradient: [colors.brandPink80, colors.brandPink80],
        // secondary: colors.yellowLight,
        // secondaryGradient: [colors.yellow, colors.yellowLight],
        secondary: colors.pink,
        secondaryGradient: [colors.pinkDark, colors.pink]
    },
    ranges: {
        tools: {
            would_use: [colors.blueGreenDarker, colors.blueGreenDark],
            would_not_use: [colors.red, colors.redLight],
            interested: [colors.blueGreen, colors.blueGreenLight],
            not_interested: [colors.redLighter, colors.redLightest],
            never_heard: [colors.greyLight, colors.greyLightest]
        },
        toolSections: {
            component_libraries: colors.pinkLight,
            data_fetching: colors.red,
            state_management: colors.teal,
            styling: colors.green,
            navigation: colors.orange,
            animations: colors.purple
        },
        sentiment: {
            positive: [colors.brandGreen80, colors.brandGreen80],
            neutral: [colors.grey, colors.greyLight],
            negative: [colors.brandPink80, colors.brandPink80]
        },
        // features: {
        //     used: [colors.electricBlueLight, colors.electricBlueLighter],
        //     heard: [colors.electricBlueDarker, colors.electricBlueDark],
        //     never_heard: [colors.electricBlueDarkest, colors.electricBlueDarkerer]
        // },
        features: {
            never_heard: [colors.brandSeaBlue20, colors.brandSeaBlue20],
            heard: [colors.brandSeaBlue40, colors.brandSeaBlue40],
            used: [colors.brandSeaBlue80, colors.brandSeaBlue80]
        },
        features_categories: {
            language: colors.purple,
            browser_apis: colors.pink,
            other_features: colors.green
        },
        features_simplified: {
            know_it: '#ACFFC3',
            used_it: '#59DF7F'
        },
        // gender: {
        //     male: [velocity[0], velocity[1]],
        //     female: [velocity[3], velocity[4]],
        //     non_binary: [velocity[6], velocity[7]],
        //     prefer_not_to_say: [velocity[8], velocity[9]],
        //     not_listed: [velocity[10], velocity[11]]
        // },
        // race_ethnicity: {
        //     biracial: velocity[0],
        //     black_african: velocity[1],
        //     east_asian: velocity[2],
        //     hispanic_latin: velocity[3],
        //     middle_eastern: velocity[4],
        //     multiracial: velocity[5],
        //     native_american_islander_australian: velocity[6],
        //     south_asian: velocity[7],
        //     white_european: velocity[8],
        //     south_east_asian: velocity[9],
        //     not_listed: velocity[10]
        // },
        // yearly_salary: {
        //     range_work_for_free: [velocity[0], velocity[1]],
        //     range_0_10: [velocity[2], velocity[3]],
        //     range_10_30: [velocity[4], velocity[5]],
        //     range_30_50: [velocity[6], velocity[7]],
        //     range_50_100: [velocity[8], velocity[9]],
        //     range_100_200: [velocity[10], velocity[11]],
        //     range_more_than_200: [velocity[12], velocity[13]]
        // },
        // years_of_experience: {
        //     range_less_than_1: [velocity[0], velocity[1]],
        //     range_1_2: [velocity[2], velocity[3]],
        //     range_2_5: [velocity[4], velocity[5]],
        //     range_5_10: [velocity[6], velocity[7]],
        //     range_10_20: [velocity[8], velocity[9]],
        //     range_more_than_20: [velocity[10], velocity[11]]
        // },
        // higher_education_degree: {
        //     no_degree: velocity[0],
        //     yes_related: velocity[2],
        //     yes_unrelated: velocity[4]
        // },
        opinions: {
            4: [velocity[9], velocity[8]],
            3: [velocity[7], velocity[6]],
            2: [velocity[5], velocity[4]],
            1: [velocity[3], velocity[2]],
            0: [velocity[1], velocity[0]]
        },
        bracket: {
            round1: [velocity[2], velocity[3]],
            round2: [velocity[5], velocity[6]],
            round3: [velocity[7], velocity[8]]
        }
    },
    distinct,
    countries: [
        colors.blue,
        colors.blueLight,
        colors.blueLighter,
        colors.pinkLightest,
        colors.pinkLighter,
        colors.pinkLight,
        colors.pink
    ],
    velocity,
    arrowsVelocity,
    tiers
}

export default stateOfRNThemeColors
